import { render } from "./AddTrip.vue?vue&type=template&id=3dd0ddf4"
import script from "./AddTrip.vue?vue&type=script&lang=js"
export * from "./AddTrip.vue?vue&type=script&lang=js"
script.render = render

export default script